"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = throws;
function throws(message) {
    throw new Error(message);
}
//# sourceMappingURL=throws.js.map